/*
 * Copyright 2026 ByOmakase, LLC (https://byomakase.org)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {type ObservationTrack, type ThumbnailTrack, type TimedItemsTrack, TrackType} from '../../media';
import {OmpError} from '../../types';
import {type DownsampleOptions, type TimedItemsTrackDownsampler} from './timed-items-downsampler';
import {ObservationTrackDownsampler} from './observation-track-downsampler';
import {ThumbnailTrackDownsampler} from './thumbnail-track-downsampler';

export class TimedItemsDownsamplerFactory {
  static create(track: TimedItemsTrack, options: DownsampleOptions): TimedItemsTrackDownsampler<TimedItemsTrack> {
    switch (track.trackType) {
      case TrackType.OBSERVATION_TRACK:
        return new ObservationTrackDownsampler(track as ObservationTrack, options);
      case TrackType.THUMBNAIL_TRACK:
        return new ThumbnailTrackDownsampler(track as ThumbnailTrack, options);
      default:
        throw new OmpError(`Unsupported track type for downsampling: ${track.trackType}`);
    }
  }
}
